import { useEffect } from 'react';
import { startRealtimeClient, stopRealtimeClient } from '../lib/realtime/realtimeClient';

export default function RealtimeBridge() {
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) return undefined;

    const socket = startRealtimeClient();
    return () => {
      if (socket) stopRealtimeClient();
    };
  }, []);

  return null;
}

